import { CachePersistor, LocalForageWrapper } from 'apollo3-cache-persist';
import localforage from 'localforage';
import { InMemoryCache } from '@apollo/client';

import apolloTypePolicies from './typePolicies';
import apolloPossibleTypes from './possibleTypes';

// Apollo -> set up cache
export const cache = new InMemoryCache({
  typePolicies: apolloTypePolicies,
  possibleTypes: apolloPossibleTypes,
});

/* Create persistor to handle persisting data from local storage on refresh, etc.
 * Uses CachePersistor instead of automatic persistCache method to enable more granular
 * control (if needed)
 */
export const persistor = new CachePersistor({
  cache,
  storage: new LocalForageWrapper(localforage),
});
